export class ExcelRow {
    SITE_NAME: string = null;
    PO_NUM: string = null;
    ADDRESS: string = null;
    CITY: string = null;
    PROVSTATE: string = null;
    POSTAL: string = null;
    COUNTRY: string = null;
    LATITUDE: string = null;
    LONGITUDE: string = null;
    SITE_STATUS: string = null;
    BULK_STATUS: string = null;
    ORDER_NUMBER: string = null;
    BATCH_ID: string = null;
    REC_ID: string = null;
    COLOUR: string = null;
 }